import React from 'react'

import AddIcon from 'Assets/Images/icons/add'

export const ButtonAddUnstyled = props => (
  <div className={props.className} onClick={props.onClickHandler}>
    <AddIcon />
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonAdd/unstyled.js